export const queryKeys = {
    SUBSIDIARY_ADMIN_VIEW: "SUBSIDIARY_ADMIN_VIEW"
}